import React, { useState } from 'react';
import { theme } from '@/core/theme';

import Modal from '@/components/atoms/Modal';
import { Text } from '@/components/atoms/Text';
import { SVGIcons } from '@/components/atoms/Icon/SVGIcon.interface';

const WarnShiftDelete: React.FunctionComponent = () => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <>
            <Modal
                isOpen={isOpen}
                onHide={() => {
                    setIsOpen(false);
                }}
                width={328}
                title={'pickupPoint.modal.warn.shift.title'}
                icon={SVGIcons.DANGER}
                iconColor={theme.color.bloodyMary}
                closeMessage="pickupPoint.modal.warn.shift.button"
            >
                <Text text="pickupPoint.modal.warn.shift.text" type="normal" />
            </Modal>
        </>
    );
};

export default WarnShiftDelete;
